import Image from "next/image";

export const AkashConsoleLogo = ({
  className = "",
  size = { width: 228, height: 29 }
}: {
  className?: string;
  size?: { width: number; height: number };
}) => {
  return (
    <Image
      src="/images/kadi-console.svg"
      alt="KĀDI Console"
      width={size.width}
      height={size.height}
      className={`object-contain ${className}`}
      priority
    />
  );
};
